export const NAME_REGEX = /^[A-z][A-z'-]+([ A-z][A-z'-]+)*\s*$/;
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const URL_REGEX =
  /(http|https):\/\/([a-z0-9-]+((\.[a-z0-9-]+)+)?)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
// Follows the E.164 standard https://www.itu.int/rec/T-REC-E.164/en
// From https://www.twilio.com/docs/glossary/what-e164#regex-matching-for-e164
export const PHONE_REGEX = /^\+[1-9]\d{1,14}$/;
